<div class="flex flex-col gap-6 p-6">
	<div class="flex flex-col gap-2">
		<p>Location Formatting</p>
		<ui-button-segmented
			[options]="[
				{ id: 'short', label: 'Short' },
				{ id: 'medium', label: 'Medium' },
				{ id: 'long', label: 'Long' },
			]"
			[fullWidth]="true"
			variant="text-only"
			[selectedId]="vm.dateLineFormat().locationFormat"
			(selectedIdChange)="vm.onLocationFormatChange($event)"
		></ui-button-segmented>
	</div>

	<div class="flex flex-col gap-2">
		<p>Text Formatting For 'Dated'</p>
		<app-dropdown
			[placeholder]="'Select text formatting'"
			[itemGroups]="[
				{
					items: vm.datedTextFormatItems,
				},
			]"
			[value]="vm.getDatedTextFormatName(vm.dateLineFormat().datedTextFormat)"
			(onSelect)="vm.onTextFormatChange($event.result.value)"
		></app-dropdown>
	</div>

	<div class="flex flex-col gap-2">
		<p>Date Format</p>
		<ui-button-segmented
			[options]="[
				{ id: 'longForm', label: 'Long Form' },
				{ id: 'shortForm', label: 'Short Form' },
			]"
			[fullWidth]="true"
			variant="text-only"
			[selectedId]="vm.dateLineFormat().dateFormat"
			(selectedIdChange)="vm.onDateFormatChange($event)"
		></ui-button-segmented>
	</div>

	<div
		class="flex flex-col gap-2"
		*ngIf="vm.dateLineFormat().dateFormat === 'longForm'"
	>
		<p>Preposition Format</p>
		<ui-button-segmented
			[options]="[
				{ id: 'onThis', label: 'On This' },
				{ id: 'this', label: 'This' },
			]"
			[fullWidth]="true"
			variant="text-only"
			[selectedId]="vm.dateLineFormat().prepositionFormat"
			(selectedIdChange)="vm.onPrepositionFormatChange($event)"
		></ui-button-segmented>
	</div>

	<div class="flex flex-col gap-4">
		<ui-checkbox
			label="Add Comma"
			[ngModel]="vm.dateLineFormat().addComma"
			(ngModelChange)="vm.onAddCommaChange($event)"
		></ui-checkbox>

		<ui-checkbox
			label="Signed Remotely"
			[ngModel]="vm.dateLineFormat().signedRemotely"
			(ngModelChange)="vm.onSignedRemotelyChange($event)"
		></ui-checkbox>
	</div>

	<div class="bg-grey-lightest border-grey-veryLight border p-4 rounded-lg">
		<h4 class="mb-2">Dated Line Preview Text</h4>
		<p [innerHTML]="vm.previewText()"></p>
	</div>
</div>
